<template>
  <div class="wrapper">
    <el-form ref="formJob" class="job-form" :model="jobData" label-width="">
      <el-descriptions style="margin-bottom:20px;" direction="vertical" :column="3" border>
        <el-descriptions-item label="工作单位" label-class-name="my-label">
          <el-form-item label=" " prop="workCompany">
            {{jobData.workCompany}}
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item label="岗位" label-class-name="my-label">
          <el-form-item label=" " prop="jobName" >
            {{jobData.jobName}}
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item label="薪资" label-class-name="my-label">
          <el-form-item label=" " prop="income" >
            {{jobData.income}}
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item label="芝麻分" label-class-name="my-label">
          <el-form-item label=" " prop="zmScore" >
            {{jobData.zmScore}}
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item label="在租详情" :span="2" label-class-name="my-label" content-class-name="my-content">
          <el-form-item label=" " prop="rentDetail" >
            <div class="handle">
              {{jobData.rentDetail}}
            </div>
          </el-form-item>
        </el-descriptions-item>
      </el-descriptions>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'Job',
  props: {
    jobInfo: {
      type: Object,
      default: () => {}
    },
    member: {
      type: Object,
      default: () => {}
    },
    flag: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      jobData: {
        memberId: '',
        workCompany: '',
        jobName: '',
        income: '',
        zmScore: '',
        rentDetail: ''
      }
    }
  },
  watch: {
    jobInfo: {
      handler(newV, oldV) {
        if (newV && this.flag) this.jobData = this.jobInfo
      }
    }
  },
  provide() {
    return {
      context: this
    }
  },
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.wrapper /deep/ {
  width: 100%;
  .el-descriptions {
    .my-label {
      color: #1a1e25;
      background: #fafafa;
    }
    .my-content {
      .handle {
        display: flex;
        justify-content: space-between;
        & > span {
          &:first-child {
            margin-right: 20px;
            flex: 1;
          }
        }
      }
    }
  }
  .job-form {
    .el-form-item {
      margin-bottom: 0;
    }
  }
}
</style>
